import { ObservableArray, View } from "binder"
import { ControlPlanVersionViewModel, ControlPlanViewModel } from "./controlPlan-viewModel"
import { ProductSelector } from "src/erp/inventory/rawData/product/productSelector";
import { MeasureParameterGroupSelector } from "../measuredParameterGroup/selectors/measureParameterGroupSelector";
import { Popup } from "leaflet";
import { ServerSideDataLoader } from "uicomponents";

export class ControlPlanView extends View<ControlPlanViewModel>{
    GetViewUniqueId(): string {
        return "V-E50CA01C-BBC9-4152-8383-F6EEDBDCA872"
    }
    loadHtml(): string {
        let element = require('./controlPlan.html').default;
        let style = require('./controlPlan.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: Popup) { this._popup = v; } public get popup(): Popup { return this._popup;} private _popup: Popup;
    public set productSearchableSelector(v: ProductSelector) { this._productSearchableSelector = v; } public get productSearchableSelector(): ProductSelector { return this._productSearchableSelector;} private _productSearchableSelector: ProductSelector;
    public set measureParameterGroupSelector(v: MeasureParameterGroupSelector) { this._measureParameterGroupSelector = v; } public get measureParameterGroupSelector(): MeasureParameterGroupSelector { return this._measureParameterGroupSelector;} private _measureParameterGroupSelector: MeasureParameterGroupSelector;
    public set controlPlanVersions(v: ObservableArray<ControlPlanVersionViewModel>) { this._controlPlanVersions = v; } public get controlPlanVersions(): ObservableArray<ControlPlanVersionViewModel> { return this._controlPlanVersions;} private _controlPlanVersions: ObservableArray<ControlPlanVersionViewModel>;
    public set canCreateNewControlPlanVersion(v: boolean) { this._canCreateNewControlPlanVersion = v; } public get canCreateNewControlPlanVersion(): boolean { return this._canCreateNewControlPlanVersion; } private _canCreateNewControlPlanVersion: boolean;
    public set isActiveVersiondChanged(v: boolean) { this._isActiveVersiondChanged = v; } public get isActiveVersiondChanged(): boolean { return this._isActiveVersiondChanged;} private _isActiveVersiondChanged: boolean;


    createNewControlPlanVersion(){
        this.dataContext.createControlPlanVersion();
    }

    changeActiveControlPlanVersion(){
        this.dataContext.changeControlPlanActiveVersion();
    }
}
